// MainView's scrolling container keeps its position across routes.
export const scrollMainToTop = () =>
  document.getElementById("scrolling-container")?.scrollTo({ top: 0 });
